import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface ProductCategory {
  id: string;
  company_id: string;
  code: string;
  name: string;
  description: string | null;
  default_tax_code: "TAX" | "NON";
  income_account_min: string;
  income_account_max: string;
  cogs_account_min: string;
  cogs_account_max: string;
  allowed_units: string[];
  auto_code_prefix: string;
  is_active: boolean;
  sort_order: number;
}

export function useProductCategories() {
  const { user } = useAuth();
  return useQuery<ProductCategory[]>({
    queryKey: ["product_categories"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("product_categories")
        .select("*")
        .eq("is_active", true)
        .order("sort_order");
      if (error) throw error;
      return (data ?? []) as unknown as ProductCategory[];
    },
    enabled: !!user,
  });
}
